import { FunctionComponent } from 'react';
import Form, { FormProps } from 'antd/lib/form';
import styled from 'styled-components';

export const ContractTermsFormStyled: FunctionComponent<FormProps> = styled(Form)`
  .ant-form-item {
    margin-bottom: 0.5rem;
  }
`;

export const ContractTermFormDrawerFooter = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
